import { useAuth0 } from '@auth0/auth0-react';
import config from '../config/auth0';

export function useApiToken() {
  const { getAccessTokenSilently } = useAuth0();

  const getAccessToken = async () => {
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: config.auth0Audience,
        },
      });
      return accessToken;
    } catch (error) {
      console.error('Error getting access token:', error);
      throw error;
    }
  };

  return getAccessToken;
} 